import React from 'react';

const PartialHouse: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <path
      fill="currentColor"
      d="M70.487 48.76l-19.25-19.25a1.75 1.75 0 00-2.475 0l-19.25 19.25a1.75 1.75 0 001.238 2.988h2.187a.437.437 0 01.438.437v17.063a1.75 1.75 0 001.75 1.75h10.062a.438.438 0 00.438-.438v-8.312a4.375 4.375 0 018.75 0v8.312a.437.437 0 00.437.438h10.063a1.75 1.75 0 001.75-1.75V52.185a.437.437 0 01.437-.437h2.188a1.75 1.75 0 001.237-2.987z"
    ></path>
    <path
      fill="currentColor"
      d="M43.731 5.433C21.846 8.483 5 27.275 5 50c0 24.853 20.147 45 45 45s45-20.147 45-45S74.853 5 50 5h-.004V0A49.992 49.992 0 01100 49.992 50.004 50.004 0 0130.862 96.19 49.99 49.99 0 01.004 49.992 49.293 49.293 0 0143.034.478l.697 4.955z"
    ></path>
  </svg>
);

export default PartialHouse;
